import React from 'react';
import { BsTelephone } from 'react-icons/bs';
import { GrFacebook, GrInstagram, GrLocation, GrMailOption } from 'react-icons/gr';
import { YMaps, Placemark, Map } from "react-yandex-maps";

import './main.css'

export default function MapsAndContacts() {
    const fer = [40.391041, 71.786351]
    return (
        <>
            <div className="maps">
                <div className="contact">
                    <h1>Наши контакты</h1>
                    <div className="group">
                        <div className="icon">
                            <BsTelephone className='icon-phone' />
                        </div>
                        <div className="phone">
                            <h3>+7 (800) 000-00-00</h3>
                            <ul>
                                <li>Ежедневно с 9:00 до 18:00</li>
                            </ul>
                        </div>
                    </div>
                    <div className="group">
                        <div className="icon">
                            <GrLocation className='icon-phone' />
                        </div>
                        <div className="phone">
                            <h3>Адрес:</h3>
                            <ul>
                                <li>г. Челябинск,ул. Валдайская 25, оф.51</li>
                                <li>Пн-Сб с 9:00 до 18:00</li>
                            </ul>
                        </div>
                    </div>
                    <div className="group">
                        <div className="icon">
                            <GrMailOption className='icon-phone' />
                        </div>
                        <div className="phone">
                            <h3>Email:</h3>
                            <ul>
                                <li>oficewindow@gmail.com</li>
                            </ul>
                        </div>
                    </div>
                    <h3 className='url-title'>Мы в соц.сетях</h3>
                    <div className="url-group">
                        <GrInstagram />
                        <GrFacebook />
                        <i class="fa-brands fa-vk"></i>
                    </div>
                </div>
                <div className={'location__side'}>
                    <YMaps style={{ width: '100%', height: '100%' }}>
                        <Map defaultState={{ center: [...fer], zoom: 18 }} width={'100%'} height={'100%'}>
                            <Placemark geometry={fer}
                                properties={{
                                    hintContent: 'Собственный значок метки',
                                    balloonContent: 'Это красивая метка'
                                }}
                                options={{
                                    iconLayout: 'default#image',
                                    iconImageHref: 'images/myIcon.gif',
                                    iconImageSize: [30, 42],
                                    iconImageOffset: [-3, -42]
                                }}
                            />
                        </Map>
                    </YMaps>
                </div>
            </div>
        </>
    )
}
